import { render, staticRenderFns } from "./widget_alerts.vue?vue&type=template&id=4543641e&scoped=true&"
import script from "./widget_alerts.vue?vue&type=script&lang=js&"
export * from "./widget_alerts.vue?vue&type=script&lang=js&"
import style0 from "./widget_alerts.vue?vue&type=style&index=0&id=4543641e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543641e",
  null
  
)

export default component.exports